import React from 'react';
import { getComputedCSSVariable } from '../../../../utils/cssVariableHelpers';

interface Props {
  color?: string,
  style?: object,
}

const UserHollowSVG: React.FC<Props> = ({
  color,
  style,
}) => {
  return (
    <span
      className="d-flex svg-wrapper"
      style={style}
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        version="1.1"
        baseProfile="tiny"
        x="0px"
        y="0px"
        viewBox="0 0 24 24"
        overflow="scroll"
        xmlSpace="preserve"
        fill={color}
      >
        <path d="M12,14.75c-8.8720703,0-9.2470703,7.8945313-9.25,7.9746094L2.7236328,23.5h18.5527344L21.25,22.7246094  C21.2470703,22.6445313,20.8720703,14.75,12,14.75z M4.3486328,22C4.6757813,20.2626953,6.0742188,16.25,12,16.25  c5.9267578,0,7.3242188,4.0136719,7.6513672,5.75H4.3486328z" />
        <path d="M12,13.25c2.5543213,0,4.625-2.0706787,4.625-4.625S14.5543213,4,12,4S7.375,6.0706787,7.375,8.625  S9.4456787,13.25,12,13.25z M12,5.5c1.7231445,0,3.125,1.4018555,3.125,3.125S13.7231445,11.75,12,11.75  s-3.125-1.4018555-3.125-3.125S10.2768555,5.5,12,5.5z" />
      </svg>

    </span>
  );
};

UserHollowSVG.defaultProps = {
  color: getComputedCSSVariable('table-header-text'),
  style: {
    width: '25px',
    height: '25px',
  },
};

export default UserHollowSVG;
